import { render, staticRenderFns } from "./Section4thIm.vue?vue&type=template&id=62e97411&scoped=true&"
import script from "./Section4thIm.vue?vue&type=script&lang=js&"
export * from "./Section4thIm.vue?vue&type=script&lang=js&"
import style0 from "./Section4thIm.vue?vue&type=style&index=0&id=62e97411&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e97411",
  null
  
)

export default component.exports